import type { ArrayForm, ObjectForm } from "@pdfking/forms"
import type { DestinationID } from "@pdfking/imposition"
import type { Distance, Rectangle } from "@pdfking/math"
import type { SinglePagePdf } from "@pdfking/pdfengine"
import { CreateMixin } from "@pdfking/reactivity/preact"

import type { Guide } from "#public"

export type FileCtx = {
  file_media: Record<string, SinglePagePdf>
  file_options: () => [string, string][]
  sample_media: Rectangle<Distance> | undefined
  guides: Guide[]
  // Which of the destination field's own choices the imposition accepts — see
  // `Imposition.FileDestinations`.
  file_destinations: Set<DestinationID>
  hidden_fields: string[]
  staff: boolean
}

export type ParentForm = ArrayForm<unknown> | ObjectForm<Record<string, unknown>>

export const NodeMixin = CreateMixin({
  props: {
    ctx: undefined as unknown as FileCtx,
    parent: undefined as unknown as ParentForm,
  },
})
